export default function About() {
  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-full text-teal-700 text-sm font-semibold mb-4">
            <i className="ri-lightbulb-line"></i>
            <span>Alles für dein Eqology Business</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Die komplette Business Suite<br />
            für erfolgreiche Eqology Partner
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Von der automatisierten Lead-Generierung über personalisierte Funnels bis zum 
            professionellen CRM-System – alle Tools, die du für dein erfolgreiches 
            Eqology Business brauchst, vereint in einer Plattform.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Feature 1 */}
          <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-search-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Intelligente Lead-Suche
            </h3>
            <p className="text-gray-600 leading-relaxed">
              KI-gestützte Technologie findet automatisch qualifizierte Heilberufe in deiner 
              Region und analysiert deren Websites nach NEM-Produkten. Filtere gezielt nach 
              Leads ohne bestehende NEM-Angebote für maximales Potenzial.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-flow-chart text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Personalisierte Funnels
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Erstelle deinen individuellen Funnel-Link und teile ihn auf Social Media. 
              Interessenten durchlaufen einen professionellen Quiz-Funnel und werden 
              automatisch als qualifizierte Leads erfasst.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-database-2-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Professionelles CRM
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Verwalte alle deine Leads zentral mit Pipeline-Management, automatischen 
              E-Mail-Vorlagen und detaillierten Aktivitäts-Timelines. Behalte den Überblick 
              über jeden Kontakt und seine NEM-Portfolio-Analyse.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-instagram-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Social Media Generator
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Generiere professionelle Social Media Posts mit KI-Unterstützung. Wähle aus 
              vorgefertigten Templates oder erstelle individuelle Posts für Instagram, 
              Facebook und LinkedIn – inklusive Bildern und Hashtags.
            </p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-20 grid md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">KI-gestützt</div>
            <div className="text-gray-600">Automatische Lead-Analyse</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">NEM-Filter</div>
            <div className="text-gray-600">Gezielte Portfolio-Erkennung</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">All-in-One</div>
            <div className="text-gray-600">Komplette Business Suite</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">DSGVO</div>
            <div className="text-gray-600">100% Datenschutz-konform</div>
          </div>
        </div>
      </div>
    </section>
  );
}
